<template>
    <div id="register" class="loginContainer">
        <div class="loginMainWrapper">
            <div class="loginWrapper">
                <div class="loginBoxWrapper">
                    <a-form
                            :model="formValues"
                            name="register"
                            :label-col="{ span: labelCol }"
                            :wrapper-col="{ span: wrapperCol }"
                            autocomplete="off"
                    >
                        <a-form-item :wrapper-col="{ offset: labelCol, span: wrapperCol }">
                            <div style="text-align: center">
                                <h1>欢迎注册</h1>
                            </div>
                        </a-form-item>
                        <a-form-item
                                label="用户名"
                                name="account"
                                :rules="[{ required: true, message: '请输入用户名' }]"
                                :validate-status="formErrors.accountError ? 'error' : ''"
                                :help="formErrors.accountError || '如：budechao_ict'"
                        >
                            <a-input v-model:value="formValues.account" placeholder="数字字母下划线组合，不超过20字符"/>
                        </a-form-item>

                        <a-form-item
                                label="密码"
                                name="password"
                                :validate-status="formErrors.passwordError ? 'error' : ''"
                                :help="formErrors.passwordError"
                                :rules="[{ required: true, message: '请输入密码' }]"
                        >
                            <a-input-password v-model:value="formValues.password" />
                        </a-form-item>
                        <a-form-item
                                label="确认密码"
                                name="confirm"
                                :validate-status="formErrors.confirmError ? 'error' : ''"
                                :help="formErrors.confirmError"
                                :rules="[
                                { required: true, message: '请输入确认密码' },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两个密码不一致!'));
                                  },
                                }),
                                ]"
                        >
                            <a-input-password v-model:value="formValues.confirm" />
                        </a-form-item>

                        <a-form-item
                                label="手机号"
                                name="tel"
                                :validate-status="formErrors.telError ? 'error' : ''"
                                :help="formErrors.telError"
                                :rules="[{ required: !isDEV, message: '请输入手机号' }]"
                        >
                            <a-input v-model:value="formValues.tel" placeholder="建议使用常用手机号"/>
                        </a-form-item>

                        <a-form-item
                                label="验证码"
                                name="code"
                                :validate-status="formErrors.codeError ? 'error' : ''"
                                :help="formErrors.codeError"
                                :rules="[{ required: !isDEV, message: '请输入手机验证码' }]"
                        >
                            <a-space>
                                <a-input v-model:value="formValues.code" />
                                <a-button block @click="getCode">{{btnText}}</a-button>
                            </a-space>

                        </a-form-item>


                        <a-form-item
                                label="邀请码"
                                name="auth_code"
                                :validate-status="formErrors.auth_codeError ? 'error' : ''"
                                :help="formErrors.auth_codeError"
                                :rules="[
                                    {
                                      required: true, message: '请输入系统注册邀请码!',
                                    },
                                    {len: 6, message: '请输入六位英文字符'}
                                  ]"
                        >
                            <a-input v-model:value="formValues.auth_code" placeholder="请输入系统注册邀请码"/>
                        </a-form-item>


                        <a-form-item label="单位" name="workplace"
                                     :validate-status="formErrors.workplaceError ? 'error' : ''"
                                    :help="formErrors.workplaceError"
                                     :rules="[
                                    {
                                      required: true, message: '请输入工作单位!',
                                    },
                                  ]"
                        >
                            <a-input v-model:value="formValues.workplace"  placeholder="所属单位仅允许中文。如：北京中医药大学"/>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ offset: labelCol, span: wrapperCol }">
                            <a-button type="primary" html-type="submit" block @click="handleSubmit">注&nbsp;&nbsp;册</a-button>
                        </a-form-item>

                        <a-form-item :wrapper-col="{ offset: labelCol, span: wrapperCol }">
                            <div style="text-align: center">
                                <a href="/login" class="ant-btn ant-btn-link">立即登录</a>
                            </div>
                        </a-form-item>
                    </a-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        get_code_vue,
        jy_register,
        jy_register_code,
        put_user,
        jy_code_crud,
        login_success
    } from '@/utils/api';
    import {isDEV} from '@/utils/request';
    import {jy_tip} from '@/utils/vue.tool';

    const setError = (obj, key, msg)=>{
        obj.formErrors[key + 'Error'] = msg;
        // obj.$refs.formRef.validateField(msg);
    };
    const onFinish = (obj, values) => {
        console.log('Success:', values);
        // 发起请求
        let {account, password, tel, code, auth_code, research_field, workplace, hospitalType} =values;
        // if(!research_field && !hospitalType){
        //   jy_tip('请输入工作室或选择医疗机构类别！');
        //   return;
        // }

        const toRegister = (auth_code, belong)=>{
            jy_register({account, password, tel, code}, (res1)=> {
                if(res1.status === 1){
                    research_field = research_field || hospitalType;
                    window.sessionStorage.setItem('belong', belong);
                    jy_code_crud({code: auth_code, account}, 'PUT');
                    login_success(account, password);
                    put_user( {research_field, workplace, personal_profile: auth_code}, (res_user)=>{
                        if(res_user.status === 1000001){
                            jy_tip('已注册成功', 'success');
                            //history.push('/login/');
                        }else jy_tip('已注册成功, 但工作室和单位未更新成功，' + res_user.message);
                    })
                }else if(res1.status === 10406){
                    setError(obj, 'account', `账户 ${account} 已存在`);
                }else if(res1.status === 10404){
                    setError(obj, 'code', `验证码不正确`);
                }else jy_tip(`注册失败，${res1.message}`);
            })
        };
        jy_code_crud({code: auth_code}, 'get', (res)=>{
            if(!res.code) jy_tip(res.message);
            else if(res.account) jy_tip('邀请码已被使用');
            else{
                toRegister(auth_code, res.belong);
            }
        })
    };
    const labelCol = 5;
    export default {
        name: "RegisterView",
        data() {
            return {
                isDEV,
                labelCol,
                wrapperCol: 24-labelCol,
                btnText: '获取验证码',
                formValues: {},
                formErrors: {}
            };
        },
        methods: {
            handleSubmit() {
                console.log('handleSubmit');
                onFinish(this, this.formValues);
            },
            getCode(){
                if(isDEV){
                    setError(this, 'tel', 'test error');
                    return;
                }
                get_code_vue(this.formValues, jy_register_code, (btnText)=>{
                    this.btnText = btnText;
                }, undefined, false, (errInfo)=>{
                    let {key, msg} = errInfo;
                    setError(this, key, msg);
                });
            }
        },
    }
</script>

<style scoped>
    .loginContainer{
        width: 100%;
        position: relative;
        background: url(https://img1.baidu.com/it/u=564468332,1185985646&fm=26&fmt=auto&gp=0.jpg);
        background-attachment: fixed;
        background-repeat: no-repeat !important;
        background-size: cover;
        background-position: center;
        padding-top: 105px;
        min-height: 100%;
    }
    .loginHeader span{
        font-size: 25px;
        font-weight: 700;
    }
    .loginMainWrapper{
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: center;
    }
    .loginWrapper{
        width: 90%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: row;
        height: 100%;
    }

    @media screen and (min-width: 1200px){

        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 400px;
            height: 100%;
            border-radius: 5px;
        }
    }
    @media screen and (min-width: 769px) and (max-width: 1200px){

        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 400px;
            height: 100%;
            border-radius: 5px;
        }
    }
    @media screen and (max-width: 768px){

        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 100%;
            border-radius: 5px;
        }
    }

</style>

